




















 import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

 interface TabData {
   name: string;
   label: string;
 }

 @Component({
   name: 'Tabs'
 })
export default class Tabs extends Vue {
  private tabs: TabData[] = [];

  @Prop(String)
  private initialTab!: string;

  private activeTab: string = '';

  private created() {
    this.tabs = [
      {name: 'table', label: this.$t('farms-home.tabs.table-label') as string},
      {name: 'map', label: this.$t('farms-home.tabs.map-label') as string}
    ]
  }

  private mounted() {
    if (!!this.initialTab) {
      this.setActiveTab(this.initialTab);
    } else {
      this.setActiveTab(this.tabs[0].name)
    }
  }
  
  @Emit('toggle')
  private setActiveTab(tabName: string) {
    this.activeTab = tabName;
  }
}
